<template>
	<div class="display-flex flex-column">
		<div v-if="serviceTitle" class="service-title">{{ serviceTitle }}</div>
		<div v-if="numOfActions" class="actions-description display-flex flex-row">
			Used in {{ numOfActionsText }}.
			<div v-if="!isShowingActionsDetails" @click="$emit('see-actions-details')" class="see-details ml-1">See details</div>
			<div v-else @click="$emit('close-actions-details')" class="see-details ml-1">Show less</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ConnectionServiceAndActionsDescription',
	props: {
		serviceTitle: { type: String },
		numOfActions: { type: [String, Number] },
		isShowingActionsDetails: { type: Boolean },
	},
	computed: {
		numOfActionsText() {
			return this.numOfActions + ` action${this.numOfActions > 1 ? 's' : ''}`;
		},
	},
};
</script>

<style lang="scss" scoped>
.service-title {
	font-size: 14px;
	font-weight: 500;
	color: var(--primary-font-color);
}
.actions-description {
	font-size: 12px;
	font-weight: normal;
	color: var(--secondary-font-color);

	.see-details {
		cursor: pointer;
		text-decoration: underline;
	}
}
</style>
